import { Button, Calendar, Form, Popover, Tag } from "antd";
import { defaultSettings } from "css/defaultAntStyles";
import dayjs from "dayjs";
import "./css/index.css";
import Styles from "./css/calendarwrapper.module.css";
import {
  CheckCircleOutlined,
  SendOutlined,
  SyncOutlined,
  TransactionOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";

import { DrawerWrapper } from "Components/DrawerWrapper/DrawerWrapper";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CreateBlankForm } from "./components/CreateBlankForm/CreateBlankForm";
import {
  createBlankThunk,
  deleteBlankPermanently,
  editBlankThunk,
  getSingleBlankThunk,
  getSingleSavedBlankThunk,
  onSaveDataThunk,
  selectBlank,
  sendBlankThunk,
  setDate,
  setReset,
  setSelectedMaterials,
  setSelectedWorks,
} from "AppStore/Slices/BlankSlice/BlankSlice";
import { capitalizeWords } from "Helpers/capitalizeWords";
import { TableListPage } from "Components/TableListPage/MyTable";
import { errorNotification, infoNotification } from "Components/MyNotification";
import { EditBlankForm } from "./components/EditBlankForm/EditBlankForm";
import MyBtnConfirm from "Components/MyBtnConfirm/MyBtnConfirm";
import { checkRoleAccess } from "Helpers/checkRoleAccess";
import { ROLE } from "Helpers/roles/roles";
import { selectProject } from "AppStore/Slices/ProjectSlice/ProjectSlice";
import { selectUser } from "AppStore/Slices/UserSlice/UserSlice";
import { BlanksList } from "./components/BlanksList/BlanksList";
import { SaveBlankForm } from "./components/SaveBlankForm/SaveBlankForm";
import { formatDate } from "./helpers/formatDate";
import { MyBtn } from "Components/MyBtn/MyBtn";
import { DrawerWrapperWithLoader } from "Components/DrawerWrapperWithLoader/DrawerWrapperWithLoader";
import { DndContext, DragOverlay } from "@dnd-kit/core";
import { MyListItem } from "Components/MyList/MyListItem";

export const CalendarWrapper = ({
  disabled = false,
  projectId,
  monthNumber,
  setMonthNumber,
}) => {
  const {
    projectBlanks,
    isSomeValueChanged,
    isComponentLoading,
    currentBlankStatus,
    isDrawerLoading,
    currentBlankId,
    isFormAfterSave,
  } = useSelector(selectBlank);
  const { roles } = useSelector(selectUser);
  const { userRolesForThisProject, isUserCreatorOfThisProject } =
    useSelector(selectProject);
  const [checkedDate, setCheckedDate] = useState(null);
  const [formCreate] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [formSaveBlank] = Form.useForm();
  const [openCreate, setOpenCreate] = useState(false);
  const [openSaved, setOpenSaved] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openSaveBlank, setOpenSaveBlank] = useState(false);
  const [isCanCreateBlank, setIsCanCreateBlank] = useState(false);
  const [childrenDrawer, setChildrenDrawer] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const showChildrenDrawer = () => {
    setChildrenDrawer(true);
  };
  const onChildrenDrawerClose = () => {
    setChildrenDrawer(false);
  };

  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      <Button
        disabled={disabled}
        type="primary"
        onClick={(e) => {
          e.stopPropagation();
          setOpenCreate(true);
        }}
      >
        Подати бланк
      </Button>
    </div>
  );
  const dispatch = useDispatch();

  const blanksForDate = useMemo(() => {
    if (checkedDate) {
      const blanksForSomeDate = projectBlanks
        .filter((elem) => elem[checkedDate])
        .reduce((acc, elem) => {
          elem[checkedDate].forEach((el) => {
            acc.push(el);
          });
          return acc;
        }, [])
        .sort((a, b) => (a.status > b.status ? 1 : -1));
      if (!blanksForSomeDate.length) {
        infoNotification("Немає бланків на поточну дату");
        return [];
      }
      return blanksForSomeDate;
    } else {
      return [];
    }
  }, [checkedDate, projectBlanks]);

  const getListData = (value) => {
    const dateStr = formatDate(value);

    return projectBlanks.filter((item) => item[dateStr]);
  };

  const onContextHandler = (e, date) => {
    e.preventDefault();
    dispatch(setDate(date ? date.toISOString() : ""));
  };
  const dateCellRender = (value) => {
    const listData = getListData(value);

    return checkRoleAccess(
      [ROLE.WORKER],
      userRolesForThisProject,
      false,
      roles,
    ) ? (
      <Popover
        zIndex={900}
        content={content}
        title="Виберіть дії:"
        trigger={"contextMenu"}
        styles={{
          body: {
            border: `2px solid ${defaultSettings.colorPrimary}`,
          },
        }}
        classNames={{
          root: "my-popover",
        }}
      >
        <ul
          style={{
            padding: 0,
            margin: 0,
            listStyle: "none",
            textAlign: "center",
          }}
          className={Styles["calendar-cell-scroll"]}
          onContextMenu={(e) => onContextHandler(e, value)}
        >
          {listData.map((item, index) => {
            const dateKey = Object.keys(item);

            // const dataArr = item[dateKey];
            const dataArr = [...item[dateKey]].sort((a, b) => {
              if (a.status === "новий бланк" && b.status !== "новий бланк") {
                return -1;
              }

              if (a.status !== "новий бланк" && b.status === "новий бланк") {
                return 1;
              }

              return 0;
            });
            const visibleItems = dataArr.slice(0, 3);
            const hiddenCount = dataArr.length - 3;

            const reactElements = visibleItems.map((elem) => {
              // const statusColor =
              //    elem.status === "новий бланк"
              //     ? defaultSettings.colorPrimary
              //     : // "orange"
              //       "blue";
              // const statusIcon =
              //   elem.status === "новий бланк" ? (
              //     <SyncOutlined spin />
              //   ) : (
              //     <CheckCircleOutlined />
              //   );
              let statusColor = defaultSettings.colorPrimary;
              if (elem.status === "облікований бланк") {
                statusColor = "blue";
              }
              if (elem.status === "на нарахуванні") {
                statusColor = "cyan";
              }
              let statusIcon = <SyncOutlined spin />;
              if (elem.status === "облікований бланк") {
                statusIcon = <CheckCircleOutlined />;
              }
              if (elem.status === "на нарахуванні") {
                statusIcon = <TransactionOutlined />;
              }
              return (
                <li key={elem.id}>
                  <Tag icon={statusIcon} color={statusColor}>
                    {capitalizeWords(elem.status)}
                  </Tag>
                </li>
              );
            });
            if (hiddenCount > 0) {
              reactElements.push(
                <div className="calendar-more">+ ще {hiddenCount}</div>,
              );
            }
            return reactElements;
          })}
        </ul>
      </Popover>
    ) : (
      <ul
        style={{
          padding: 0,
          margin: 0,
          listStyle: "none",
          textAlign: "center",
        }}
        className={Styles["calendar-cell-scroll"]}
      >
        {listData.map((item, index) => {
          const dateKey = Object.keys(item);

          // const dataArr = item[dateKey];
          const dataArr = [...item[dateKey]].sort((a, b) => {
            if (a.status === "новий бланк" && b.status !== "новий бланк") {
              return -1;
            }

            if (a.status !== "новий бланк" && b.status === "новий бланк") {
              return 1;
            }

            return 0;
          });
          const visibleItems = dataArr.slice(0, 3);
          const hiddenCount = dataArr.length - 3;

          const reactElements = visibleItems.map((elem) => {
            // const statusColor =
            //    elem.status === "новий бланк"
            //     ? defaultSettings.colorPrimary
            //     : // "orange"
            //       "blue";
            // const statusIcon =
            //   elem.status === "новий бланк" ? (
            //     <SyncOutlined spin />
            //   ) : (
            //     <CheckCircleOutlined />
            //   );
            let statusColor = defaultSettings.colorPrimary;
            if (elem.status === "облікований бланк") {
              statusColor = "blue";
            }
            if (elem.status === "на нарахуванні") {
              statusColor = "cyan";
            }
            let statusIcon = <SyncOutlined spin />;
            if (elem.status === "облікований бланк") {
              statusIcon = <CheckCircleOutlined />;
            }
            if (elem.status === "на нарахуванні") {
              statusIcon = <TransactionOutlined />;
            }
            return (
              <li key={elem.id}>
                <Tag icon={statusIcon} color={statusColor}>
                  {capitalizeWords(elem.status)}
                </Tag>
              </li>
            );
          });
          if (hiddenCount > 0) {
            reactElements.push(
              <div className="calendar-more">+ ще {hiddenCount}</div>,
            );
          }
          return reactElements;
        })}
      </ul>
    );
  };

  const onSelect = (value) => {
    const date = formatDate(value);

    // const blanksForSomeDate = projectBlanks
    //   .filter((elem) => elem[date])
    //   .reduce((acc, elem) => {
    //     elem[date].forEach((el) => {
    //       acc.push(el);
    //     });
    //     return acc;
    //   }, []);
    // if (!blanksForSomeDate.length) {
    //   infoNotification("Немає бланків на поточну дату");
    //   return;
    // }
    setCheckedDate(date);
    // handleCloseMenu();
    // setBlanksForDate(blanksForSomeDate);
  };
  const handleClose = () => {
    setOpenCreate(false);
    setOpenSaved(false);
    setOpenSaveBlank(false);
    dispatch(setReset());
    onChildrenDrawerClose();
  };
  const handleCreate = async () => {
    const data = await dispatch(createBlankThunk(monthNumber));
    if (!Boolean(data.error)) {
      handleClose();
    }
  };

  const handleEdit = async () => {
    const isSend = !isSomeValueChanged;
    const isEdit = isSomeValueChanged;
    if (isSend) {
      const data = await dispatch(sendBlankThunk());

      if (!Boolean(data.error)) {
        onSelect(dayjs(checkedDate));
        setOpenEdit(false);
        dispatch(setReset());
        onChildrenDrawerClose();
      }

      return;
    }
    if (isEdit) {
      dispatch(editBlankThunk());
      onChildrenDrawerClose();
      return;
    }
  };
  const handleDeleteBlank = async () => {
    await dispatch(deleteBlankPermanently());
    onChildrenDrawerClose();
    setOpenEdit(false);
  };
  const columns = [
    {
      title: "Статус",
      dataIndex: "status",
      render: (status) => {
        let color = "default";
        let icon = "";
        if (status === "новий бланк") {
          color = defaultSettings.colorPrimary;
          icon = <SyncOutlined spin />;
        }
        if (status === "облікований бланк") {
          color = "blue";
          icon = <CheckCircleOutlined />;
        }
        if (status === "на нарахуванні") {
          color = "cyan";
          icon = <TransactionOutlined />;
        }

        return (
          <Tag color={color} icon={icon}>
            {capitalizeWords(status)}
          </Tag>
        );
      },
    },
    {
      title: "Створив бланк",
      dataIndex: "createdBy",
    },
  ];
  const handleRollBackToBlanksList = () => {
    handleClose();
    setOpenSaved(true);
  };
  const onRowClick = (e) => {
    const blankId = e.id;
    dispatch(getSingleBlankThunk({ blankId, projectId }));
    setOpenEdit(true);
  };

  const getSingleSavedBlank = async (blankId) => {
    dispatch(getSingleSavedBlankThunk(blankId));
  };

  useEffect(() => {
    if (isFormAfterSave && currentBlankId) {
      setOpenSaveBlank(true);
      getSingleSavedBlank(currentBlankId);
    }
  }, [currentBlankId, isFormAfterSave]);

  const onSaveDataBlank = async () => {
    await dispatch(onSaveDataThunk());
    handleClose();
  };
  const handleDragStart = (event) => {
    const typeOfEventIsWorks =
      event.active.data.current.type === "works" ? true : false;
    let valueToSet = {
      ...event.active.data.current.item,
      type: event.active.data.current.type,
      fromDragger: true,
    };
    if (typeOfEventIsWorks) {
      valueToSet = {
        ...valueToSet,
        comment: "",
        value: 0,
        allowedWorkTypeId: valueToSet.id,
        materialsForWork: valueToSet.materialsForWork.map((el) => {
          return { ...el, value: 0, restCountAfterChanges: el.restCount };
        }),
      };
    } else {
      valueToSet = {
        ...valueToSet,
        restCountAfterChanges: valueToSet.restCount,
        value: 0,
        workTypeTied: valueToSet["workTypeTied.id"]
          ? {
              allowedWorkTypeId: valueToSet["workTypeTied.id"],
              title: valueToSet["workTypeTied.title"],
              code: valueToSet["workTypeTied.code"],
              code_norm: valueToSet["workTypeTied.code_norm"],
              unit: valueToSet["workTypeTied.unit"],
              value: 0,
              comment: "",
              connectionWithMaterial: true,
            }
          : null,
      };
    }

    setActiveItem(valueToSet);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return;

    const dragType = active.data.current.type;
    const dropType = over.data.current.type;

    if (dragType !== dropType) {
      if (dragType === "works" && dropType === "materials") {
        errorNotification("Роботи вставляємо лише в роботи");
      } else {
        errorNotification("Матеріали вставляємо лише в матеріали");
      }
      return; // Не дозволяємо кидати роботу в матеріали і навпаки
    }

    if (dragType === "works") {
      dispatch(setSelectedWorks(activeItem));
    }

    if (dragType === "materials") {
      dispatch(setSelectedMaterials(activeItem));
    }
    setActiveItem(null);
  };

  return (
    <div>
      {checkRoleAccess(
        [ROLE.WORKER],
        userRolesForThisProject,
        false,
        roles,
      ) && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <Button
            disabled={disabled}
            type="primary"
            onClick={() => {
              dispatch(setReset());
              setOpenCreate(true);
            }}
          >
            Подати бланк
          </Button>
          <Button
            disabled={disabled}
            type="primary"
            onClick={() => {
              setOpenSaved(true);
            }}
          >
            Збережені бланки
          </Button>
        </div>
      )}
      <DndContext onDragEnd={handleDragEnd} onDragStart={handleDragStart}>
        <Calendar
          onPanelChange={(value, mode) => {
            if (mode === "month") {
              const month = value.month() + 1; // dayjs: 0-11
              setMonthNumber(month);
            }
          }}
          locale={dayjs.locale("uk")}
          cellRender={dateCellRender}
          onSelect={(value, info) => {
            if (info.source === "date") {
              onSelect(value);
            }
          }}
        />

        <DrawerWrapper
          withoutConfirm
          width="50%"
          disabled={disabled}
          open={openSaved}
          setOpen={() => {
            setOpenSaved(false);
            dispatch(setReset());
          }}
          placement="right"
          destroyOnHidden={true}
        >
          <BlanksList
            projectId={projectId}
            isLoading={isDrawerLoading}
            close={handleClose}
          />
        </DrawerWrapper>

        <DrawerWrapper
          headerBtn={() => {
            if (!childrenDrawer)
              return (
                <MyBtn
                  text={"Відкрити список"}
                  type="default"
                  onClick={showChildrenDrawer}
                  icon={<UnorderedListOutlined />}
                />
              );
          }}
          width="50%"
          disabled={disabled}
          title="Створення бланку"
          showCreateBtn={isCanCreateBlank}
          isLoading={isComponentLoading || isDrawerLoading}
          open={openCreate}
          // onConfirm={() => {
          //   setOpenCreate(false);
          //   dispatch(setReset());
          //   setChildrenDrawer(false);
          // }}
          setOpen={() => {
            setOpenCreate(false);
            dispatch(setReset());
            setChildrenDrawer(false);
          }}
          form={formCreate}
          placement="right"
          push={false}
        >
          {openCreate ? (
            <CreateBlankForm
              isCanCreate={(param) => setIsCanCreateBlank(param)}
              form={formCreate}
              onFinish={handleCreate}
              disabled={disabled}
              onSaveData={onSaveDataBlank}
              activeItem={activeItem}
            />
          ) : (
            <></>
          )}

          <DrawerWrapperWithLoader
            projectId={projectId}
            title="Перелік робіт та матеріалів"
            width="50%"
            closable={true}
            setOpen={onChildrenDrawerClose}
            open={childrenDrawer}
            placement="left"
          />
        </DrawerWrapper>

        <DrawerWrapper
          headerBtn={() => {
            if (!childrenDrawer)
              return (
                <MyBtn
                  text={"Відкрити список"}
                  type="default"
                  onClick={showChildrenDrawer}
                  icon={<UnorderedListOutlined />}
                />
              );
          }}
          width="50%"
          disabled={disabled}
          title="Збережений бланк"
          showCreateBtn={isCanCreateBlank}
          isLoading={isDrawerLoading}
          open={openSaveBlank}
          setOpen={() => {
            setOpenSaveBlank(false);
            dispatch(setReset());
            setChildrenDrawer(false);
          }}
          placement="right"
          form={formSaveBlank}
          push={false}
        >
          {openSaveBlank ? (
            <SaveBlankForm
              isCanCreate={(param) => setIsCanCreateBlank(param)}
              disabled={disabled}
              form={formSaveBlank}
              rollback={handleRollBackToBlanksList}
              onSaveData={onSaveDataBlank}
              onFinish={handleCreate}
              activeItem={activeItem}
            />
          ) : (
            <></>
          )}
          <DrawerWrapperWithLoader
            projectId={projectId}
            title="Перелік робіт та матеріалів"
            width="50%"
            closable={true}
            setOpen={onChildrenDrawerClose}
            open={childrenDrawer}
            placement="left"
          />
        </DrawerWrapper>

        <DrawerWrapper
          width="50%"
          showDeleteBtn={true}
          handleConfirmDelete={handleDeleteBlank}
          disabled={
            disabled ||
            currentBlankStatus === "облікований бланк" ||
            currentBlankStatus === "на нарахуванні" ||
            !checkRoleAccess(
              [ROLE.ENGINEER, ROLE.WORKER],
              userRolesForThisProject,
              isUserCreatorOfThisProject,
              roles,
            )
          }
          title="Бланк виконаних робіт"
          showSendBtn={!isSomeValueChanged}
          showEditBtn={isSomeValueChanged}
          isLoading={isComponentLoading}
          open={openEdit}
          setOpen={() => {
            dispatch(setReset());
            setOpenEdit(false);
            setChildrenDrawer(false);
          }}
          form={formEdit}
          placement="right"
          headerBtn={
            checkRoleAccess(
              [ROLE.ENGINEER],
              userRolesForThisProject,
              isUserCreatorOfThisProject,
              roles,
            )
              ? () => (
                  <>
                    {!childrenDrawer &&
                    currentBlankStatus !== "облікований бланк" ? (
                      <MyBtn
                        text={"Відкрити список"}
                        type="default"
                        onClick={showChildrenDrawer}
                        icon={<UnorderedListOutlined />}
                      />
                    ) : (
                      <></>
                    )}
                    <MyBtnConfirm
                      mainTitle={
                        "Ви дійсно хочете відправити бланк на нарахування?"
                      }
                      textBtn={"На нарахування"}
                      icon={
                        <SendOutlined
                          style={{ color: defaultSettings.colorPrimary }}
                        />
                      }
                      btnIcon={<SendOutlined />}
                      isLoading={isComponentLoading}
                      disabled={
                        disabled ||
                        currentBlankStatus === "облікований бланк" ||
                        currentBlankStatus === "на нарахуванні" ||
                        isSomeValueChanged
                      }
                      onConfirm={handleEdit}
                    />
                  </>
                )
              : () => {
                  if (!childrenDrawer)
                    return (
                      <MyBtn
                        text={"Відкрити список"}
                        type="default"
                        onClick={showChildrenDrawer}
                        icon={<UnorderedListOutlined />}
                      />
                    );
                }
          }
          push={false}
        >
          {openEdit ? (
            <EditBlankForm
              form={formEdit}
              onFinish={handleEdit}
              activeItem={activeItem}
              disabled={
                disabled ||
                currentBlankStatus === "облікований бланк" ||
                currentBlankStatus === "на нарахуванні" ||
                !checkRoleAccess(
                  [ROLE.ENGINEER, ROLE.WORKER],
                  userRolesForThisProject,
                  isUserCreatorOfThisProject,
                  roles,
                )
              }
            />
          ) : (
            <></>
          )}
          <DrawerWrapperWithLoader
            projectId={projectId}
            title="Перелік робіт та матеріалів"
            width="50%"
            closable={true}
            setOpen={onChildrenDrawerClose}
            open={childrenDrawer}
            placement="left"
          />
        </DrawerWrapper>

        <DrawerWrapper
          withoutConfirm
          padding={8}
          title={`Список бланків на ${checkedDate}`}
          open={blanksForDate.length}
          setOpen={() => {
            setCheckedDate(null);
          }}
          form={formCreate}
          placement="left"
        >
          <TableListPage
            padding="8px"
            headerOn={false}
            filtersOn={false}
            columns={columns}
            data={blanksForDate}
            onRowClick={onRowClick}
          />
        </DrawerWrapper>

        <DragOverlay zIndex={999999}>
          {activeItem ? (
            <MyListItem
              item={activeItem}
              isDrag={true}
              type={activeItem.type}
            />
          ) : null}
        </DragOverlay>
      </DndContext>
    </div>
  );
};
